import ValoresClass from "src/app/model/api/datos/valoresClass";
import Paging from "src/app/model/api/generic/paging";
import DatabaseTable from "src/app/model/database/generic/databaseTable";

export default class ValoresTable extends DatabaseTable<ValoresClass> {

    public async getAll(): Promise<ValoresClass[]> {
        return await this.GetAllRecords()
    }

    public async getById(Id: number): Promise<ValoresClass> {
        let records = await this.GetRecordsById(0, 1, Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getByParametroId(ParametroId: number): Promise<ValoresClass[]> {
        return await this.GetRecordsByIndex(0, Number.MAX_VALUE, 'ParametroId', ParametroId, ParametroId)
    }

    public async getPagedByParametroId(start: number, limit: number, ParametroId: number): Promise<Paging<ValoresClass>> {
        let count = await this.GetRecordsCountIndex('ParametroId', ParametroId, ParametroId)
        let data = await this.GetRecordsByIndex(start, limit, 'ParametroId', ParametroId, ParametroId)

        let result = new Paging<ValoresClass>()
        result.page = Math.floor(start / limit) + 1
        result.total = count
        result.totalPages = Math.ceil(result.total / limit)
        result.collection = data
        result.count = data.length
        return result
    }

    public async getPaged(start: number, limit: number): Promise<Paging<ValoresClass>> {
        let count = await this.GetRecordsCount()
        let data = await this.GetRecordsPage(start, limit)

        let result = new Paging<ValoresClass>()
        result.page = Math.floor(start / limit) + 1
        result.total = count
        result.totalPages = Math.ceil(result.total / limit)
        result.collection = data
        result.count = data.length
        return result
    }

    public async update(record: ValoresClass): Promise<void> {
        await this.UpdateRecord(record)
    }

    public async delete(record: ValoresClass): Promise<void> {
        if (!record?.Id) return
        await this.DeleteRecord(record.Id)
    }

    public async deleteById(Id: number): Promise<void> {
        await this.DeleteRecord(Id)
    }

}